import React, { useState } from 'react';
import { Btn, H5, LI, UL } from '../../../AbstractElements';
import { Card, CardHeader, Col, Collapse, Row } from 'reactstrap';
import { BackendDevelopment, Design, Development, FrontendDevelopment, InterfaceDesign, KnowledgeCategories, UIDesign, UserExperience, UXDesign } from '../../../Constant';
import Sidebar2 from './Sidebar2';
import { ChevronDown, ChevronUp } from 'react-feather';

const DetailedSidebar = () => {
  const [isProfile, setisProfile] = useState(true);
  const [open, setOpen] = useState(false);
  return (
    <Col xl='3 xl-40' className='box-col-40'>
      <div className='md-sidebar'>
        <Btn onClick={(e) => setOpen(!open)} color='primary' className='md-sidebar-toggle'>
          Knowledge filter
        </Btn>
        <div className={`md-sidebar-aside custom-scrollbar custom-scrollbar ${open ? 'open' : ''}`}>
          <div className='default-according style-1 job-accordion' id='accordionoc'>
            <Row>
              <Col xl='12'>
                <Card>
                  <CardHeader>
                    <H5 className='mb-0 p-0'>
                      <Btn color='link accordion-icon' onClick={() => setisProfile(!isProfile)}>
                        {KnowledgeCategories}
                        {isProfile ? <ChevronUp /> : <ChevronDown />}
                      </Btn>
                    </H5>
                  </CardHeader>
                  <Collapse isOpen={isProfile}>
                    <div className='categories'>
                      <div className='learning-header'>
                        <span className='f-w-600'>{Design}</span>
                      </div>
                      <UL className='simple-list'>
                        <LI>
                          <a href='#javascript'>{UIDesign} </a>
                          <span className='badge badge-primary pull-right'>28</span>
                        </LI>
                        <LI>
                          <a href='#javascript'>{UXDesign} </a>
                          <span className='badge badge-primary pull-right'>35</span>
                        </LI>
                        <LI>
                          <a href='#javascript'>{InterfaceDesign} </a>
                          <span className='badge badge-primary pull-right'>17</span>
                        </LI>
                        <LI>
                          <a href='#javascript'>{UserExperience} </a>
                          <span className='badge badge-primary pull-right'>26</span>
                        </LI>
                      </UL>
                    </div>
                    <div className='categories pt-0'>
                      <div className='learning-header'>
                        <span className='f-w-600'>{Development}</span>
                      </div>
                      <UL className='simple-list'>
                        <LI>
                          <a href='#javascript'>{FrontendDevelopment}</a>
                          <span className='badge badge-primary pull-right'>48</span>
                        </LI>
                        <LI>
                          <a href='#javascript'>{BackendDevelopment}</a>
                          <span className='badge badge-primary pull-right'>19</span>
                        </LI>
                      </UL>
                    </div>
                  </Collapse>
                </Card>
              </Col>
              <Sidebar2 />
            </Row>
          </div>
        </div>
      </div>
    </Col>
  );
};
export default DetailedSidebar;
